<template>
  <div class="content">
    <!-- Solo en la maqueta: en el bundle de produccion no entra. -->
    <AvisoVistaPrevia v-if="avisaVistaPrevia" />
    <Header />
    <!-- Sin <Transition>: el fundido "out-in" bloqueaba la navegacion cuando el
         navegador pausa los requestAnimationFrame (pestana en segundo plano, movil
         con throttling...), dejando el detalle en blanco y rompiendo el boton atras.
         La navegacion instantanea es fiable en cualquier condicion. -->
    <router-view v-slot="{ Component, route }">
      <component :is="Component" :key="route.path" />
    </router-view>
    <!-- Ios pwa instructions -->
    <modalIos
      :showModal="showModalIos"
      @closePwaModal="pwaDeclined()"
    ></modalIos>

    <!-- geolocation range -->
    <modal :showModal="showRangeModal" contentWidth="315px">
      <template #content>
        <div class="modal-helper">
          <div class="modal-helper__elements">
            <IconMapPinExclamation />
            <p class="modal-helper__elements--title text-center">
              {{ $t('home.geolocation.modal.title') }}
            </p>
            <p class="modal-helper__elements--subtitle text-center">
              {{ $t('home.geolocation.modal.subTitle') }}
            </p>
          </div>
          <button
            class="button-md text__primary-50 button-home"
            @click="store.dispatch('updateGeolocationRangeModal', false)"
          >
            {{ $t('home.geolocation.modal.button') }}
          </button>
        </div>
      </template>
    </modal>
  </div>
  <Footer />
</template>

<script setup>
  import Header from '@/layouts/vertical/Header.vue'
  import AvisoVistaPrevia from '@/components/AvisoVistaPrevia.vue'
  import Footer from '@/layouts/vertical/Footer.vue'
  import router from '@/router'
  import { onMounted, ref, watch, computed } from 'vue'
  import { useStore } from 'vuex'
  import { userPlatform, pwaDenied } from '@/plugins/iosSupport'
  import { IconMapPinExclamation } from '@tabler/icons-vue'
  import checkActivityUser from '@/plugins/checkActivityUser'
  import { geolocationRangeTimeout } from '@/plugins/geolocation'
  import modal from '@/components/movistar/modals/Modal.vue'
  import modalIos from '@/components/movistar/modals/ModalIos.vue'
  import getDeviceFromNearedShop from '@/plugins/getDeviceFromNearedShop'
  import mainMessageMethodListener from '@/plugins/listenerMessageMethod'
  import { useI18n } from 'vue-i18n'
  import commonMethods from '@/commonMethods'

  /*
   * El aviso de vista previa se enciende solo en la maqueta. En produccion la
   * bandera no esta puesta y no se pinta nunca —ademas de que alli la cookie
   * no existe—, aunque el componente si viaje en el bundle.
   */
  const avisaVistaPrevia = process.env.VUE_APP_VISTA_PREVIA === 'true'

  const { locale } = useI18n({ useScope: 'global' })
  const { translate } = commonMethods()

  console.log(location.search)

  const getURLParameter = (name) => {
    return (
      decodeURIComponent(
        (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
          location.search
          // eslint-disable-next-line no-sparse-arrays
        ) || [, ''])[1].replace(/\+/g, '%20')
      ) || null
    )
  }

  const langParam = getURLParameter('lang')
  const pathParam = getURLParameter('path')
  const deviceIdParam = getURLParameter('deviceId')
  const placeParam = getURLParameter('place')
  const procedureParam = getURLParameter('procedure')
  const averageWaitingTimeParam = getURLParameter('averageWaitingTime')
  const codeParam = getURLParameter('code')
  const turnParam = getURLParameter('turn')
  const experienceParam = getURLParameter('experience')
  const slotParam = getURLParameter('slot')
  const typeParam = getURLParameter('type')
  const audienceParam = getURLParameter('audience')

  let path = ref(router.currentRoute.value.path)
  let showModalIos = ref(false)
  let deviceRangeTimeout = ref(false)
  const store = useStore()
  const FingerprintJS = require('@fingerprintjs/fingerprintjs')
  const fpPromise = FingerprintJS.load()

  let deviceId = computed(() => store.getters['getDeviceId'])
  const types = computed(() => store.getters['getExperienceTypes'])

  //const showRangeModal = computed(() => store.state.common.deviceRangeModal)
  const showRangeModal = false;
  const emits = defineEmits(['closePwaModal'])

  watch(
    () => router.currentRoute.value.path,
    (newVal) => {
      path.value = newVal
    }
  )

  onMounted(() => {
    //Check if there are any activity
    window.addEventListener('touchstart', () => checkActivityUser())
    window.addEventListener('click', () => checkActivityUser())
    window.addEventListener('visibilitychange', () => {
      const visibilityApp = document.visibilityState
      if (visibilityApp === 'visible') {
        checkActivityUser()
      }
    })
    window.addEventListener('beforeinstallprompt', function (e) {
      // Prevent showing the prompt
      e.preventDefault()
    })

    // Firebase Notification Listener
    navigator.serviceWorker.addEventListener('message', function (event) {
      console.log('In addEventListener')
      mainMessageMethodListener(event)
    })

    // Check the range timeout
    setInterval(checkGeolocationRange, 60000)

    // Set user lang
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.active.postMessage({
          type: 'SET_USER_LANG',
          lang: document.documentElement.getAttribute('lang')
        })
      })
    }

    function isSafari() {
      const userAgent = navigator.userAgent
      const vendor = navigator.vendor

      const isSafari =
        userAgent.includes('Safari') &&
        vendor.includes('Apple') &&
        !userAgent.includes('Chrome') &&
        !userAgent.includes('CriOS') &&
        !userAgent.includes('FxiOS')
      return isSafari
    }

    if (isSafari()) {
      document.body.classList.add('is-safari')
    }

    // Update position each 10min
    setInterval(checkAndUpdateIpAndLocation, 600000)
    // Check PWA install
    checkPwaInstall()
  })

  const checkPwaInstall = () => {
    let platform = userPlatform()
    store.commit('setDevicePwaAllow', platform.pwaAllowed)
  }

  const pwaDeclined = () => {
    showModalIos.value = pwaDenied()
    store.commit('setDevicePwaAllow', false)
  }

  async function checkGeolocationRange() {
    if (!deviceRangeTimeout.value) {
      let checkRange = await geolocationRangeTimeout()
      deviceRangeTimeout.value = checkRange
    }
  }

  async function checkAndUpdateIpAndLocation() {
    store.dispatch('updateIpAndGeolocation')
  }

  const getInfoDeviceAndCreateSession = async (deviceId) => {
    store.commit('setDeviceId', deviceId)
    store.dispatch('getDeviceInfo')
    await store.dispatch('createSession')
    store.dispatch('getExperienceTypes')
  }

  const getDeviceInfoAndCreateSession = (deviceId) => {
    return new Promise((resolve, reject) => {
      try {
        if (!deviceId) {
          store.dispatch('generateSessionLocalStorageAndLocation').then(() => {
            getDeviceFromNearedShop().then((response) => {
              deviceId = response.deviceId
              store.commit('setDeviceLatitude', response.latitude)
              store.commit('setDeviceLongitude', response.longitude)
              store.commit('setDeviceRange', response.range)

              getInfoDeviceAndCreateSession(deviceId).then(() => resolve(true))
            })
          })
        } else {
          getInfoDeviceAndCreateSession(deviceId).then(() => resolve(true))
        }
      } catch (err) {
        reject(err)
      }
    })
  }

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms))

  if (!deviceId.value) {
    deviceId.value = deviceIdParam
  }

  const manageToken = async (path) => {
    try {
      await sleep(5000)

      // Get the visitor identifier when you need it.
      const fp = await fpPromise
      const result = await fp.get()

      let fbToken = store.state.session.fbToken
      while (fbToken === null) {
        fbToken = store.state.session.fbToken
        await sleep(200)
      }

      if (path === 'turn' || path === 'booking') {
        store.dispatch('updateTurnSession', {
          token: fbToken,
          turnCode: turnParam,
          client: result.visitorId
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  getDeviceInfoAndCreateSession(deviceId.value).then(async () => {
    if (langParam) {
      locale.value = langParam
    }

    if (pathParam) {
      manageToken(pathParam)

      let params = {}
      let query = {}

      if (pathParam === 'commercial') {
        const place = placeParam
        if (place) {
          mainMessageMethodListener({
            data: {
              action: 'showCommercial',
              place: place
            }
          })
        } else {
          query = { procedure: procedureParam || 'visible' }
        }
      } else if (pathParam === 'turn') {
        store.dispatch('updateTurn', {
          averageWaitingTime: averageWaitingTimeParam,
          turnCode: codeParam
        })
      } else if (pathParam === 'booking') {
        await store.dispatch('getExperience', experienceParam)
        store.dispatch('updateSlot', new Date(slotParam))
        store.commit('setExperienceType', { code: typeParam })
        store.commit('setAppointment', { turnCode: turnParam })
        params = { audience: audienceParam }
      } else if (pathParam === 'experiencesByType') {
        if (typeParam === 'CINE') {
          router.push({ name: 'Cinema' })
          return
        } else {
          await store.dispatch('getExperiencesByTypeCode', typeParam)

          params = {
            experienceTypeCode: typeParam?.toUpperCase()
          }
        }
      } else if (pathParam === 'experience') {
        if (typeParam === 'CINE') {
          router.push({ name: 'Cinema' })
          return
        } else {
          while (!types.value || types.value.length == 0) {
            await new Promise((r) => setTimeout(r, 200))
          }

          const type = types.value.find(
            (ftype) => ftype.code == typeParam?.toUpperCase()
          )

          store.commit('setExperienceType', type)
          await store.dispatch('getExperienceByCode', codeParam)
        }
      } else if (pathParam === 'personalData') {
        getExperienceType(typeParam.toUpperCase())
        store.dispatch('getExperienceByCode', codeParam)

        params = {
          audience: audienceParam || 1
        }

        if (slotParam) {
          store.commit('setSlot', new Date(Number.parseInt(slotParam)))
        }
      }

      router.push({
        name: pathParam.replace(/(?<=(?:^|[.?!])\W*)[a-z]/g, (i) =>
          i.toUpperCase()
        ),
        params: params,
        query: query
      })
    }
  })

  const getExperienceType = async (experienceTypeCode) => {
    while (!types.value || types.value.length == 0) {
      await new Promise((r) => setTimeout(r, 200))
    }

    const type = types.value.find((ftype) => ftype.code == experienceTypeCode)

    store.commit('setExperienceType', type)
  }
</script>

<style lang="scss">
  @import '@/scss/theme.scss';
  .modal-helper {
    @include d-flex(column, center, center, 2vh);
    padding: 1.5vh 0;
    &__elements {
      @include d-flex(column, center, center, 0.85vh);
      padding: 1.5vh 0;
      &--title {
        font-size: var(--fs-small);
        font-weight: var(--fw-bold);
        line-height: 20px;
      }
      &--subtitle {
        font-size: var(--fs-x-small);
        font-weight: 400;
        line-height: 16px;
        &--assessment {
          font-family: var(--open-sans-semiBold);
          font-weight: var(--fw-medium);
        }
      }
    }
  }
</style>
